export default import.meta.ROLLDOWN_FILE_URL_KY10e_wUtMddDOEHtdDYJg